import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-api-cache-settings',
  templateUrl: './api-cache-settings.component.html',
  styleUrls: ['./api-cache-settings.component.scss']
})
export class ApiCacheSettingsComponent implements OnInit {

  isCache = false;
  constructor() { }

  ngOnInit() {
  }

}
